import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AssignedWorkoutCard = ({ workout, isTrainer, onStatusUpdate }) => {
  const statusColors = {
    scheduled: 'text-blue-600 bg-blue-100',
    in_progress: 'text-yellow-600 bg-yellow-100',
    completed: 'text-green-600 bg-green-100',
    skipped: 'text-gray-600 bg-gray-100'
  };

  const statusIcons = {
    scheduled: 'Calendar',
    in_progress: 'Play',
    completed: 'CheckCircle',
    skipped: 'XCircle'
  };

  return (
    <motion.div
      className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
      whileHover={{ y: -4 }}
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="font-semibold text-foreground text-lg mb-2">
            {workout?.workoutPlan?.name}
          </h3>
          <span className={`text-xs px-2 py-1 rounded-full ${statusColors?.[workout?.status]}`}>
            {workout?.status?.replace('_', ' ')}
          </span>
        </div>
        <Icon name={statusIcons?.[workout?.status]} size={24} className="text-primary" />
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Calendar" size={16} />
          <span>{format(new Date(workout?.scheduledDate), 'MMM dd, yyyy')}</span>
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>{workout?.workoutPlan?.durationMinutes} minutes</span>
        </div>

        {isTrainer ? (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="User" size={16} />
            <span>{workout?.client?.fullName}</span>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="User" size={16} />
            <span>Trainer: {workout?.trainer?.fullName}</span>
          </div>
        )}
      </div>
      {workout?.notes && (
        <p className="text-sm text-muted-foreground mb-4 p-3 bg-muted rounded-lg">
          {workout?.notes}
        </p>
      )}
      {!isTrainer && workout?.status === 'scheduled' && (
        <div className="flex gap-2">
          <Button
            size="sm"
            fullWidth
            onClick={() => onStatusUpdate(workout?.id, 'in_progress')}
          >
            <Icon name="Play" size={16} className="mr-2" />
            Start Workout
          </Button>
        </div>
      )}
      {!isTrainer && workout?.status === 'in_progress' && (
        <div className="flex gap-2">
          <Button
            size="sm"
            fullWidth
            onClick={() => onStatusUpdate(workout?.id, 'completed')}
          >
            <Icon name="CheckCircle" size={16} className="mr-2" />
            Complete
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => onStatusUpdate(workout?.id, 'skipped')}
          >
            Skip
          </Button>
        </div>
      )}
      {workout?.completedAt && (
        <div className="mt-4 pt-4 border-t border-border text-xs text-muted-foreground">
          Completed: {format(new Date(workout?.completedAt), 'MMM dd, yyyy HH:mm')}
        </div>
      )}
    </motion.div>
  );
};

export default AssignedWorkoutCard;